import { createConsumer, createSubscriber, IConsumer, IEvent } from '@cian/events-log';

import { setPushNotificationsAllowed, setPushSettingsModalOpened } from '../../../actions/page';
import { TThunkAction } from '../../../types/redux';

export const PUSH_TOPIC = 'push_settings';
export const PUSH_SKIP = 'skip';
export const PUSH_ALLOW = 'allow';

const getConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getConsumer._instance) {
    getConsumer._instance = createConsumer({ topic: PUSH_TOPIC });
  }

  return getConsumer._instance;
};

export interface IParams {
  onAllow?(): void;
  onSkip?(): void;
}

export const requestPushSettingModal =
  (parameters?: IParams): TThunkAction =>
  dispatch => {
    if (typeof window === 'undefined') {
      return;
    }

    const consumer = getConsumer();

    dispatch(setPushSettingsModalOpened(true));

    const subscriber = createSubscriber(async (event: IEvent<unknown>) => {
      if (event.type === PUSH_SKIP) {
        dispatch(setPushNotificationsAllowed(false));

        if (parameters && parameters.onSkip) {
          parameters.onSkip();
        }
      }

      if (event.type === PUSH_ALLOW) {
        dispatch(setPushNotificationsAllowed(true));

        if (parameters && parameters.onAllow) {
          parameters.onAllow();
        }
      }

      consumer.unsubscribe(subscriber);
      dispatch(setPushSettingsModalOpened(false));
    });

    consumer.subscribe(subscriber);
  };

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };
